import { render, staticRenderFns } from "./T1ExtraCard.vue?vue&type=template&id=7ff4d8a7&scoped=true&"
import script from "./T1ExtraCard.vue?vue&type=script&lang=js&"
export * from "./T1ExtraCard.vue?vue&type=script&lang=js&"
import style0 from "./T1ExtraCard.vue?vue&type=style&index=0&id=7ff4d8a7&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7ff4d8a7",
  null
  
)

export default component.exports